/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
import { sort } from '@ember/object/computed';
import { action } from '@ember/object';
// Internal Imports

export default class PermissionReplyHistory extends Component {
  // Services
  @service
  store;

  permissionReply = null;
  @tracked
  permissionReplies = null;
  @tracked
  dialogOpen = false;
  permissionSort = Object.freeze(['createTime:desc']);

  @sort('permissionReplies', 'permissionSort')
  sortedPermissionReplies;

  @action
  openDialog() {
    this.store
      .query('events/permission-reply', {
        schoolId: this.permissionReply.event.get('school.id'),
        eventId: this.permissionReply.event.get('id'),
        personId: this.permissionReply.person.get('id'),
      })
      .then((replies) => {
        if (replies.length) {
          this.permissionReplies = replies;
        }
        this.dialogOpen = true;
      });
  }
}
